module.exports = __webpack_public_path__ + "media/src/application/images/show-desc-beaa7337b49f8f96ff2cbc6cc896d29a.svg";